import { EMPTY_STATE_IMAGES } from '@sketch-note/design-system/src/shared/constants';
import { Navigation } from '@sketch-note/design-system/src/shared/site-settings';
import { differenceInMinutes, parseISO } from 'date-fns';
import addDays from 'date-fns/addDays';
import addHours from 'date-fns/addHours';
import formatISO from 'date-fns/formatISO';
import subDays from 'date-fns/subDays';
import Router from 'next/router';
import { useEffect, useState } from 'react';
import { Node } from 'slate';
import { API, endpoints } from 'src/api';
import { formatCreationData } from 'src/api';
import { formatFileResponse } from 'src/features/files';
import useSWR from 'swr';
export async function fetchGettingStarted() {
  try {
    const response = await API.get('/dashboard/get_started');
    if (response.data.success) {
      return response.data;
    }
  } catch (error) {
    return null;
  }
  return null;
}

async function fetchDashboardProTip() {
  try {
    const response = await API.get('/dashboard/protip');

    if (response.data.success) {
      return response.data;
    }
  } catch (error) {
    return null;
  }
  return null;
}

async function fetchOrganizations() {
  try {
    const response = await API.get('/settings/orgs');
    if (response.data) {
      return response.data;
    }
  } catch (error) {
    return null;
  }
  return null;
}

export async function fetchDashboardMessage() {
  try {
    const response = await API.get('/dashboard/message');

    if (response.data.success) {
      return response.data;
    }
  } catch (error) {
    return null;
  }
  return null;
}

export async function fetchAssignedTask() {
  try {
    const response = await API.get('/dashboard/recent_tasks?limit=5');
    if (response.data.success) {
      return response.data;
    }
  } catch (error) {
    return null;
  }
  return null;
}
export async function fetchRecommendation() {
  try {
    const response = await API.get(
      '/dashboard/recommendations?r_start=0&r_limit=4&kl_start=0&kl_limit=3&kd_start=0&kd_limit=3'
    );
    if (response) {
      return response;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}
export async function fetchDashboardBoards() {
  try {
    const response = await API.get('/dashboard/sections?get=boards&limit=3');
    if (response) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}
export async function fetchDashboardDocs() {
  try {
    const response = await API.get('dashboard/sections?get=documents&limit=3');
    if (response) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}
export async function fetchDashboardTemplates() {
  try {
    const response = await API.get('/dashboard/sections?get=templates&limit=3');
    if (response) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

// async function fetchRecentTasks() {
//   try {
//     const response = await API.get(`/files?page=1&limit=50&filter=favorite`);
//     const data = response.data.data.files;
//     if (data) {
//       const favoriteFiles = data.map((file) => formatFileResponse(file));
//       return favoriteFiles;
//     }
//   } catch (error) {
//     console.error(error);
//     return null;
//   }
//   return null;
// }

async function fetchDashboardFavoriteFiles() {
  try {
    const response = await API.get(`/files?page=1&limit=50&filter=favorite`);
    const data = response.data.data.files;
    if (data) {
      const favoriteFiles = data.map((file) => formatFileResponse(file));
      return favoriteFiles;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

async function fetchDashboardFiles() {
  try {
    const response = await API.get(`/files?limit=5&continue=1`);
    const data = response.data.data.files;
    if (response) {
      const workspaceFiles = data.map((file) => formatFileResponse(file));
      return workspaceFiles;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

export const fetchUpcomingDeadlines = async (page: number, limit: number) => {
  try {
    const response = await API.get(`/dashboard/upcoming-deadlines?page=${page}&limit=${limit}`);
    if (response.data.success) {
      return response;
    }
  } catch (error) {
    return null;
  }
  return null;
};

export async function fetchDashboardKeepLearning() {
  try {
    const response = await API.get(
      '/dashboard?r_start=0&r_limit=5&kl_start=0&kl_limit=2&kd_start=0&kd_limit=3'
    );
    if (response) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

export const fetchDashboardStatistics = async () => {
  try {
    const response = await API.get('/dashboard/statistics');
    if (response.data.success) {
      return formatStatisticsData(response.data.statistics);
    }
  } catch (error) {
    return null;
  }
  return null;
};

export async function fetchDashboardNotepad() {
  try {
    const response = await API.get('/notepad');
    return response.data.data.text;
  } catch (e) {
    console.error(e);
    return null;
  }
}

async function saveDashboardNotepad(blocks: any[]) {
  try {
    const response = await API.post('/notepad', {
      text: blocks,
    });
    if (response.data.success) {
      return true;
    }
  } catch (e) {
    console.error(e);
    return false;
  }
  return false;
}

async function authGoogleCalendars(code: string) {
  try {
    const response = await API.post('/integrations/auth?type=google', { code });
    if (response) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

async function fetchGoogleCalendars() {
  try {
    const response = await API.get('/integrations?type=google');
    if (response) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

async function removeGoogleCalendars(id: string) {
  try {
    const response = await API.delete(`/integrations/auth?type=google&id=${id}`);
    if (response) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

export const useDashboard = () => {
  endpoints.dashboard.r_start = 0;
  endpoints.dashboard.r_limit = 5;
  endpoints.dashboard.kl_start = 0;
  endpoints.dashboard.kl_limit = 3;
  endpoints.dashboard.kd_start = 0;
  endpoints.dashboard.kd_limit = 3;

  const { data, error } = useSWR(endpoints.dashboard.url, API.get);

  const dashboardData: any = {
    sections: [],
  };

  if (data?.data) {
    if (data.data.user.signUpQueries) {
      Router.push(Navigation.SigningUserInfo.href);
    }
    if (data.data.keepDoing) {
      dashboardData.sections.push({
        category: {
          label: 'Recent templates',
          translationKey: 'dashboard-recent-templates',
        },
        type: 'creations',
        items: data.data?.keepDoing?.map((creation) => formatCreationData(creation)),
        cta: {
          label: 'View all',
          translationKey: 'dashboard-view-all',
          slug: '/creations',
        },
      });
    }
    if (data.data.keepLearning) {
      dashboardData.sections.push({
        category: {
          label: 'Keep learning',
          translationKey: 'dashboard-keep-learning',
        },
        type: 'lesson',
        items: data.data?.keepLearning?.map((learning) => ({
          title: learning.title,
          tag: {
            label: learning.tag.label,
            value: learning.tag.value,
            color: learning.tag.color,
          },
          imageUrl: learning.image.url,
          slug: learning.slug,
          progress: learning.progress,
          isLearning: true,
          nextCardId: learning.next,
          nextCardType: learning.type,
        })),
        cta: {
          label: 'View all',
          translationKey: 'dashboard-view-all',
          slug: Navigation.MyLessons.href,
        },
      });
    }

    if (data.data.recommendation_result) {
      dashboardData.sections.push({
        category: {
          label: 'We recommend',
          translationKey: 'dashboard-recommended-title',
        },
        type: 'lesson',
        items: data.data?.recommendation_result?.map((recommendation) => ({
          title: recommendation.title,
          tag: {
            label: recommendation.tag.label,
            id: recommendation.tag.id,
            value: recommendation.tag.value,
            color: recommendation.tag.color,
          },
          imageUrl: recommendation.image.url,
          description: recommendation.description,
          slug: recommendation.slug,
          nextCardId: recommendation.next,
          nextCardType: recommendation.next_type,
        })),
        cta: {
          label: 'View more',
          translationKey: 'dashboard-recommended-cta',
          slug: '/catalog/category/recommendations',
        },
      });
    }
    if (data.data.statistics) {
      dashboardData.statistics = {
        streak: `${data.data.statistics.streakDay} ${
          data.data.statistics.streakDay > 1 ? 'days' : 'day'
        }`,
        level: data.data.statistics.target,
        items: [
          {
            type: 'progress',
            title: 'General progress',
            progress: {
              currentPoints: data.data.statistics.points,
              targetPoints: data.data.statistics.targetPoints,
              targetLevel: data.data.statistics.target,
            },

            levelAchieved: {
              levels: data.data.statistics.level_achieved,
              title: 'Levels achieved',
            },
          },
          {
            type: 'streaks',
            title: 'Streaks',
            description:
              'Earn 10xP for every day you learn a lesson or work on a creation with  Sketchnote.',
            streakDay: data.data.statistics.streakDay,
            streaksItem: data.data.statistics.streak.map((obj) => ({
              day: obj.day,
              points: obj.points,
              isUnlocked: obj.done,
            })),
          },

          {
            type: 'achievements',
            title: 'Achievements',
            description:
              'Earn more points and keep learning with Sketchnote to collect achievements.',
            latestAchievements: {
              title: 'Your latest achievements',
              description: 'View your last four achievements',
              timeline: data.data.statistics.achievements.sort((a, b) =>
                a.timestamp < b.timestamp ? 1 : b.timestamp < a.timestamp ? -1 : 0
              ),
            },
          },
          {
            type: 'experiencePointsDetailed',
            title: 'How do I earn experience points',
            actionPoints: [
              'Complete reading each card.',
              'Answer the MCQ questions correctly in the active learning part of the learn module',
              'Complete tasks in the create module.',
            ],
            image: EMPTY_STATE_IMAGES.statisticsAchievement,
          },
          {
            type: 'knowMoreAction',
            title: 'Need to know more?',
            description: 'We are here to help you!',
            actionBtnTxt: 'Visit help center',
          },
        ],
      };
    }
  }

  return {
    dashboardData,
    isLoading: !error && !data,
    error,
  };
};

export const useGoogleEvents = () => {
  return null;
};

export const useTasksByDate = (date: Date) => {
  const [formattedData, setFormattedData] = useState<any[]>([]);

  const fetchCalenderData = async (startDate) => {
    const formattedStart = formatISO(subDays(startDate, 1));
    const formattedEnd = formatISO(addDays(startDate, 1));
    const data = await API.get(
      `/dashboard/tasks-by-date?limit=5&start=${formattedStart}&end=${formattedEnd}`
    );
    if (data && data.data.data?.length) {
      const allData = data.data?.data?.map((item) => {
        const taskData: any = {
          id: item._id,
          // title: item.name.map((name) => Node.string(name)).join(' '),
          title: item.name,
          resource: {
            itemId: item._id,
            boardId: item?.board?._id,
            type: item.type || 'task',
            googleCalendarId: item.calendarId,
            googleEventId: item.eventId,
            calendarEmail: item.email,
          },
          borderColor: item.backgroundColor || '#254DDA',
          allDay: false,
        };

        if (item.start_date) {
          taskData.start = parseISO(item.start_date);
        }
        if (item.end_date) {
          taskData.end = parseISO(item.end_date);
          if (differenceInMinutes(parseISO(item.end_date), parseISO(item.start_date)) >= 1439) {
            taskData.allDay = true;
          }
        } else {
          taskData.end = addHours(parseISO(item.start_date), 24);
        }
        return taskData;
      });
      setFormattedData(allData);
    }
  };

  const updateTaskItem = (id: string, start: any, end: any) => {
    const tasks: any[] = [...formattedData];

    const updatedTaskIndex = tasks.findIndex((t) => t.id === id);

    if (updatedTaskIndex > -1) {
      tasks[updatedTaskIndex].start = start;
      tasks[updatedTaskIndex].end = end;
    }

    setFormattedData(tasks);
  };

  return { formattedData, updateTaskItem, fetchCalenderData };
};

const formatStatisticsData = (data: any) => {
  return {
    streak: `${data.data.statistics.streakDay} ${
      data.data.statistics.streakDay > 1 ? 'days' : 'day'
    }`,
    level: data.data.statistics.level ?? data.data.statistics.target,
    items: [
      {
        type: 'progress',
        title: 'General progress',
        progress: {
          currentPoints: data.data.statistics.points,
          targetPoints: data.data.statistics.targetPoints,
          targetLevel: data.data.statistics.target,
        },

        levelAchieved: {
          levels: data.data.statistics.level_achieved,
          title: 'Levels achieved',
        },
      },
      {
        type: 'streaks',
        title: 'Streaks',
        description:
          'Earn 10xP for every day you learn a lesson or work on a creation with  Sketchnote.',
        streakDay: data.data.statistics.streakDay,
        streaksItem: data.data.statistics.streak.map((obj) => ({
          day: obj.day,
          points: obj.points,
          isUnlocked: obj.done,
        })),
      },

      {
        type: 'achievements',
        title: 'Achievements',
        description: 'Earn more points and keep learning with Sketchnote to collect achievements.',
        latestAchievements: {
          title: 'Your latest achievements',
          description: 'View your last four achievements',
          timeline: data.data.statistics.achievements.sort((a, b) =>
            a.timestamp < b.timestamp ? 1 : b.timestamp < a.timestamp ? -1 : 0
          ),
        },
      },
      {
        type: 'experiencePointsDetailed',
        title: 'How do I earn experience points',
        actionPoints: [
          'Complete reading each card.',
          'Answer the MCQ questions correctly in the active learning part of the learn module',
          'Complete tasks in the create module.',
        ],
        image: EMPTY_STATE_IMAGES.statisticsAchievement,
      },
      {
        type: 'knowMoreAction',
        title: 'Need to know more?',
        description: 'We are here to help you!',
        actionBtnTxt: 'Visit help center',
      },
    ],
  };
};

export const useDashboardService = () => {
  return {
    fetchGettingStarted,
    fetchAssignedTask,
    fetchDashboardDocs,
    fetchRecommendation,
    fetchDashboardMessage,
    fetchDashboardBoards,
    fetchDashboardTemplates,
    fetchDashboardKeepLearning,
    fetchDashboardNotepad,
    fetchOrganizations,
    fetchDashboardProTip,
    // fetchRecentTasks,
    fetchDashboardFavoriteFiles,
    fetchDashboardFiles,
    saveDashboardNotepad,
    fetchUpcomingDeadlines,
    authGoogleCalendars,
    removeGoogleCalendars,
    fetchGoogleCalendars,
    fetchDashboardStatistics,
  };
};

export default useDashboard;
